/** Where `query` occurs in `text`, as [start, end) offsets. Empty for an empty query. */
export function findMatches(text: string, query: string, caseSensitive: boolean): Array<[number, number]> {
  if (!query) return []
  const haystack = caseSensitive ? text : text.toLowerCase()
  const needle = caseSensitive ? query : query.toLowerCase()
  const matches: Array<[number, number]> = []
  for (let at = haystack.indexOf(needle); at !== -1; at = haystack.indexOf(needle, at + needle.length)) {
    matches.push([at, at + needle.length])
  }
  return matches
}

/** The match to go to from the caret: the first at or after it, wrapping round; backwards likewise. */
export function nextMatch(matches: Array<[number, number]>, caret: number, backwards: boolean): number {
  if (matches.length === 0) return -1
  if (backwards) {
    for (let i = matches.length - 1; i >= 0; i--) if (matches[i]![0] < caret) return i
    return matches.length - 1
  }
  const index = matches.findIndex(([start]) => start >= caret)
  return index === -1 ? 0 : index
}

/** The 1-based line a text offset falls on. */
export function lineOf(text: string, offset: number): number {
  let line = 1
  for (let i = 0; i < offset && i < text.length; i++) if (text.charCodeAt(i) === 10) line++
  return line
}
